import { DateField } from '@mews-commander/form';
import { LocalizedMinorHighlight } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Accordion, Divider, Stack } from '@optimus-web/core';
import { AccordionProps } from '@optimus-web/core/src/Accordion/Accordion';
import { ACCORDION_HEADER_SPACING, FILTERS_SPACING, ProductCheckListFilterFieldsDataTestId } from './constants';
import { AdvancedSettingsSectionFIelds } from './sections/AdvancedSettingsSectionFIelds';
import { ProductsSectionFields } from './sections/ProductsSectionFields';
import { ReservationsSectionFields } from './sections/ReservationsSectionFields';
import { FilterValueKey, ProductCheckListFilterSection } from './types';
import { useExpandedFiltersSectionsState } from './utils/useExpandedFiltersSectionsState';

const getAccordionProps = (
    sectionExpanded: boolean
): Pick<AccordionProps, 'withBodyBorder' | 'withHeaderBorder' | 'headerPadding' | 'bodyPadding' | 'expanded'> => ({
    withHeaderBorder: false,
    withBodyBorder: false,
    headerPadding: {
        bottom: !sectionExpanded ? '0' : ACCORDION_HEADER_SPACING,
        top: '0',
        left: '0',
        right: '0',
    },
    bodyPadding: '0',
    expanded: sectionExpanded,
});

export const ProductCheckListFilterFields: React.FC = () => {
    const { expandedSections, toggleExpandedSection } = useExpandedFiltersSectionsState();

    return (
        <Stack vertical spacing={FILTERS_SPACING}>
            <DateField
                required
                name={FilterValueKey.date}
                label={<LocalizedText textKey={TextKey.Date} />}
                mode="utc"
                data-test-id={ProductCheckListFilterFieldsDataTestId.date}
            />

            <Divider />

            <Accordion
                {...getAccordionProps(expandedSections[ProductCheckListFilterSection.Products])}
                title={<LocalizedMinorHighlight textKey={TextKey.ProductPlural} />}
                onClick={() => toggleExpandedSection(ProductCheckListFilterSection.Products)}
                body={<ProductsSectionFields />}
                data-test-id={ProductCheckListFilterFieldsDataTestId.productsSection}
            />

            <Divider />

            <Accordion
                {...getAccordionProps(expandedSections[ProductCheckListFilterSection.Reservations])}
                title={<LocalizedMinorHighlight textKey={TextKey.ReservationPlural} />}
                onClick={() => toggleExpandedSection(ProductCheckListFilterSection.Reservations)}
                body={<ReservationsSectionFields />}
                data-test-id={ProductCheckListFilterFieldsDataTestId.reservationSection}
            />

            <Divider />

            <Accordion
                {...getAccordionProps(expandedSections[ProductCheckListFilterSection.AdvancedSettings])}
                title={<LocalizedMinorHighlight textKey={TextKey.AdvancedSettings} />}
                onClick={() => toggleExpandedSection(ProductCheckListFilterSection.AdvancedSettings)}
                body={<AdvancedSettingsSectionFIelds />}
                data-test-id={ProductCheckListFilterFieldsDataTestId.advancedSettings}
            />
        </Stack>
    );
};
